// This function will return a round number e.g. £100 instead of £100.00

export const formatPrice = (
  price: number,
  currency = "£",
  fractionLen = 2
): string => {
  if (price % 1 === 0) return `${currency}${price}`
  return `${currency}${Number(price).toFixed(fractionLen)}`
}
